import { render, staticRenderFns } from "./ContentHealthDetail.vue?vue&type=template&id=a3343952&scoped=true"
import script from "./ContentHealthDetail.vue?vue&type=script&lang=js"
export * from "./ContentHealthDetail.vue?vue&type=script&lang=js"
import style0 from "./ContentHealthDetail.vue?vue&type=style&index=0&id=a3343952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3343952",
  null
  
)

export default component.exports